<template>
    <product-discount-base
        :discount="discount"
    >
        <template v-slot:default="{ formattedPercentage }">
            <div class="product-discount">
                <p class="card-subtitle">
                    {{ discount.name }}
                </p>
                {{ formattedPercentage }}% ({{ discount.amount | currency }})
            </div>
        </template>
    </product-discount-base>
</template>

<script>
export default {
    name: 'PercentProductDiscount',
    props: {
        discount: {
            type: Object,
            required: true
        }
    }
}
</script>